<script setup lang="ts">
    import { useViewControlsClusterViewModel } from '@/views/3d-planner/view-controls/useViewControlsClusterViewModel';

    // Visible in stem/cup modes, and only when the CT slice row is open — the
    // outlines only matter on the CT cross-sections.
    const vm = useViewControlsClusterViewModel();
</script>

<template>
    <v-switch
        v-if="vm.showOutlinesVisible"
        v-model="vm.showImplantOutline"
        class="app-switch outlines-toggle"
        label="Show Implant Outlines"
        color="success"
        density="compact"
        inset
        base-color="rgb(var(--v-theme-grey-light-1))"
        hide-details
    />
</template>

<style scoped lang="scss">
    .outlines-toggle {
        // Vuetify's inset track defaults to ~0.6 opacity, which reads as
        // washed-out against the dark view-controls bar.
        :deep(.v-switch__track) {
            opacity: 1 !important;
        }
        :deep(.v-label) {
            opacity: 1;
            // v-label defaults to a dark on-surface colour; force white so
            // the label is legible against the CT row's dark-background.
            color: rgb(var(--v-theme-white));
            // v-input's v-label renders at ~1rem (16px) by default — too
            // large next to the 14px bar buttons. Pin to match.
            font-size: 14px;
        }
    }
</style>
